@if (product$ | async) {
  <nes-dialog
    full-screen="false"
    nes-id="some-id"
    heading="Product Details"
    [active]="true"
    [buttons]="[
      { label: 'Accept', action: 'accept', variant: 'primary' },
      { label: 'Decline', action: 'decline', variant: 'secondary' },
    ]"
    (nesOnHideComplete)="closeDialog()"
  >
    <div slot="content">
      <div class="nes-flex nes-justify-between nes-items-center">
        <div [cypress]="'product_title'" class="nes-flex nes-items-center">
          <nes-icon-detail
            class="nes-mr-5"
            [name]="(product$ | async).icon"
            color="blue"
          ></nes-icon-detail>
          <nes-heading tag="h3" size="2xl" class="nes-flex nes-items-center">
            <strong>{{
              "COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS." + currentProduct + ".TITLE"
                | translate
            }}</strong>
          </nes-heading>
        </div>

        <div class="pricedetails nes-flex nes-justify-between nes-items-center">
          @if (currentProduct === ProductIdentifier.Traject) {
            <nes-text color="blue" size="base" weight="bold">
              {{
                "COMPOSE.PRODUCTS_OVERVIEW.PRICE_TRAJECT_DEPENDENT" | translate
              }}
            </nes-text>
          } @else {
            <nes-price
              size="xl"
              [price]="(product$ | async).price / 100"
              stacked
              [trailingText]="
                '/' + ('FREQUENTION.MONTH_ABBREVIATION' | translate)
              "
            ></nes-price>
          }
        </div>
      </div>
      <nes-divider class="nes-my-5"></nes-divider>
      <ng-container class="nes-max-w-prose">
        @for (
          section of ["BENEFITS", "ORDER_METHOD", "GOOD_TO_KNOW"];
          track $index
        ) {
          <div class="nes-mb-10">
            <nes-heading
              tag="h3"
              size="2xl"
              [innerHTML]="
                'COMPOSE.PRODUCTS_OVERVIEW.READ_MORE_PRODUCTS.' +
                  currentProduct +
                  '.' +
                  section +
                  '.HEADER' | translate
              "
            ></nes-heading>
            @if (section === "ORDER_METHOD") {
              <nes-highlight-box class="nes-mb-2" weight="bold" size="base">
                {{
                  "COMPOSE.PRODUCTS_OVERVIEW.READ_MORE_PRODUCTS." +
                    currentProduct +
                    "." +
                    section +
                    ".SUBTEXT" | translate
                }}
              </nes-highlight-box>
            }

            <nes-text-list
              list-type="checked"
              size="base"
              color="text-body"
              class="nes-mb-2"
            >
              @for (
                item of "COMPOSE.PRODUCTS_OVERVIEW.READ_MORE_PRODUCTS." +
                  currentProduct +
                  "." +
                  section +
                  ".LIST" | translate;
                track $index
              ) {
                <nes-text-list-item
                  ><span [innerHTML]="item"></span
                ></nes-text-list-item>
              }
            </nes-text-list>
          </div>
        }
      </ng-container>
      <nes-divider class="nes-mb-5"></nes-divider>
    </div>
    <div slot="button-group-footer">
      <nes-button
        type="button"
        [cypress]="'dialog_accept'"
        (click)="onAccept()"
        [class.button--secondary]="currentProduct === ProductIdentifier.Traject"
        variant="brand"
        class="mr-2"
      >
        {{
          currentProduct === ProductIdentifier.Traject
            ? ("BUTTON.CONFIGURE_SUBSCRIPTION" | translate)
            : ("BUTTON.CHOOSE_SUBSCRIPTION" | translate)
        }}
      </nes-button>
      <nes-button
        [cypress]="'dialog_decline'"
        type="button"
        (click)="closeDialog()"
        variant="tertiary"
      >
        {{ "BUTTON.CANCEL" | translate }}
      </nes-button>
    </div>
  </nes-dialog>
}
